import { connect } from 'react-redux'
import View from './index'
import {stdAction, ACTIONS} from '../../actions/Actions'

const mapStateToProps = (state, ownProps) => {
  return {
	  companies: state.companies.index,
	  selected_companies: state.companies.selected
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
	  getCompanies: ({values, successAction}) => dispatch(stdAction(ACTIONS.companies.index, values,  () => {	   
	    if(typeof(successAction)==='function')
		    successAction()
	  })),
	  selectCompnaies: (id, issuing_companies) =>  dispatch({type: ACTIONS.companies.select, id: id, issuing_companies: issuing_companies}),
  }
}

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(View)

export default Container
